// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__cRi2Z","label":"SetPasswdForm_label__aLfB1"};